<template>
  <div class="acordo-container">
    <div class="acordo-content">
      <Descricao :titulo="'Nomenclatura'" :descricao="dados.nomenclatura_acordo" />

      <Descricao :titulo="'Código'" :descricao="dados.codigo_acordo" />
    </div>
    <Separador :dado="dados" />

    <div class="acordo-content">
      <Descricao :titulo="'Descrição'" :descricao="dados.descricao_acordo" />

      <Descricao :titulo="'Description'" :descricao="dados.descripcion_description" />
    </div>
    <Separador :dado="dados" />

    <div class="acordo-content">
      <Descricao :titulo="'Acordo'" :descricao="dados.acordo" />

      <Descricao :titulo="'Instrumento (Acordo ALADI)'" :descricao="dados.instrumento_negociacao" />
    </div>
    <Separador :dado="dados.nota" />
    <Notificacao v-if="dados.nota" :tipo="'nota'" :texto="dados.nota" />
    <Separador :dado="dados" />
    <BaseLegal :classe="classe" :base_legal="dados.base_legal_acordo" />
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import Separador from "@/components/Fields/Separador/Separador.vue";

export default {
  name: "AcordoComercial",

  props: {
    dados: Array | Object,
    classe: String
  },

  components: {
    BaseLegal,
    Descricao,
    Separador,
    Notificacao
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.acordo-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}
</style>
